module.exports = __webpack_public_path__ + "images/support/support-page-banner-2ed424ff.jpg";